import React, { useState, useEffect, useRef } from 'react'
import { Link } from 'react-router-dom'
import { getOrganisationCategories, getProductsByCategory } from '../../services/categoryService'
import { formatPrice } from '../../lib/utils'
import bgone from '../../assets/images/background/bg-5.png'
import Bgtwo from '../../assets/images/background/bg-6.png'

// Fallback image if product has no images
const PLACEHOLDER_IMAGE = 'https://placehold.co/100x100?text=No+Image';

const decodeHtml = (html) => {
  if (typeof document === 'undefined') return html;
  const txt = document.createElement("textarea");
  txt.innerHTML = html;
  return txt.value;
};

function Menusection() {
    const [categories, setCategories] = useState([]);
    const [activeCategory, setActiveCategory] = useState(null);
    const [products, setProducts] = useState([]);
    const [loading, setLoading] = useState(false);
    
    // Refs to prevent API spam and handle race conditions
    const loadingRef = useRef(false);
    const abortControllerRef = useRef(null);

    // Fetch categories on mount
    useEffect(() => {
        const fetchCategories = async () => {
            try {
                const result = await getOrganisationCategories();
                // Take max 6 categories
                const slicedCategories = result.slice(0, 6);
                setCategories(slicedCategories);
                if (slicedCategories.length > 0) {
                    setActiveCategory(slicedCategories[0]);
                }
            } catch (error) {
                console.error("Error fetching categories:", error);
            }
        };
        fetchCategories();
    }, []);

    // Fetch products when active category changes
    useEffect(() => {
        if (!activeCategory) return;

        const fetchProducts = async () => {
            // Abort previous pending request if any
            if (abortControllerRef.current) {
                abortControllerRef.current.abort();
            }

            const controller = new AbortController();
            abortControllerRef.current = controller;

            setLoading(true);
            loadingRef.current = true;

            try {
                // Fetch only 6 products
                const result = await getProductsByCategory(activeCategory.id, 1, 6);
                
                if (controller.signal.aborted) return;

                setProducts(result.items || []);
            } catch (error) {
                if (controller.signal.aborted) return;
                console.error(`Error fetching products for category ${activeCategory.name}:`, error);
            } finally {
                if (!controller.signal.aborted) {
                    setLoading(false);
                    loadingRef.current = false;
                    abortControllerRef.current = null;
                }
            }
        };

        fetchProducts();

        return () => {
            if (abortControllerRef.current) {
                abortControllerRef.current.abort();
            }
        };
    }, [activeCategory]);

    // Split products into two columns
    const leftColumnProducts = products.filter((_, i) => i % 2 === 0);
    const rightColumnProducts = products.filter((_, i) => i % 2 !== 0);

    return (
        <>
            <section className="menu-section">

                <div className="left-bg"><img src={bgone} alt="" title="" /></div>

                <div className="right-bg"><img src={Bgtwo} alt="" title="" /></div>

                <div className="auto-container">
                    <div className="title-box centered">
                        <div className="subtitle"><span>Sekcija specijaliteta</span></div>

                        <div className="pattern-image">
                            <img src={require('../../assets/images/icons/separator.svg').default} alt='mySvgImage' />
                        </div>

                        <h2>Meni za svakoga</h2>
                    </div>

                    <div className="tabs-box menu-tabs">
                        <div className="buttons">
                            <ul className="tab-buttons clearfix">
                                {categories.map((cat) => (
                                    <li 
                                        key={cat.id} 
                                        className={`tab-btn ${activeCategory?.id === cat.id ? "active-btn" : ""}`} 
                                        onClick={() => setActiveCategory(cat)}
                                    >
                                        <span>{cat.name.toUpperCase()}</span>
                                    </li>
                                ))}
                            </ul>
                        </div>
                        <div className="tabs-content">
                            <div className="tab active-tab" id="tab-1" style={{ display: 'block' }}>
                                <div className="row clearfix">
                                    <div className="menu-col col-lg-6 col-md-12 col-sm-12">
                                        <div className="inner">
                                            {loading ? (
                                                <div style={{ textAlign: 'center', padding: '20px' }}>Učitavanje...</div>
                                            ) : (
                                                leftColumnProducts.map((product) => (
                                                    <div className="dish-block" key={product.id}>
                                                        <div className="inner-box">
                                                            <div className="dish-image">
                                                                <Link to="#">
                                                                    <img 
                                                                        src={product.image_urls && product.image_urls.length > 0 ? product.image_urls[0] : PLACEHOLDER_IMAGE} 
                                                                        alt={product.name} 
                                                                        style={{ width: '100px', height: '100px', objectFit: 'cover', borderRadius: '50%' }}
                                                                    />
                                                                </Link>
                                                            </div>
                                                            <div className="title clearfix">
                                                                <div className="ttl clearfix">
                                                                    <h5><Link to="#">{product.name}</Link></h5>
                                                                </div>
                                                                <div className="price">
                                                                    <span>
                                                                        {product.retail_price?.amount 
                                                                            ? formatPrice(product.retail_price.amount, product.retail_price.currency_code || 'USD') 
                                                                            : 'N/A'}
                                                                    </span>
                                                                </div>
                                                            </div>
                                                            <div className="text desc">
                                                                <Link to="#">
                                                                    {product.description ? decodeHtml(product.description).replace(/<[^>]*>?/gm, '') : ''}
                                                                </Link>
                                                            </div>
                                                        </div>
                                                    </div>
                                                ))
                                            )}
                                        </div>
                                    </div>
                                    <div className="menu-col col-lg-6 col-md-12 col-sm-12">
                                        <div className="inner">
                                            {!loading && rightColumnProducts.map((product) => (
                                                <div className="dish-block" key={product.id}>
                                                    <div className="inner-box">
                                                        <div className="dish-image">
                                                            <Link to="#">
                                                                <img 
                                                                    src={product.image_urls && product.image_urls.length > 0 ? product.image_urls[0] : PLACEHOLDER_IMAGE} 
                                                                    alt={product.name} 
                                                                    style={{ width: '100px', height: '100px', objectFit: 'cover', borderRadius: '50%' }}
                                                                />
                                                            </Link>
                                                        </div>
                                                        <div className="title clearfix">
                                                            <div className="ttl clearfix">
                                                                <h5><Link to="#">{product.name}</Link></h5>
                                                            </div>
                                                            <div className="price">
                                                                <span>
                                                                    {product.retail_price?.amount 
                                                                        ? formatPrice(product.retail_price.amount, product.retail_price.currency_code || 'USD') 
                                                                        : 'N/A'}
                                                                </span>
                                                            </div>
                                                        </div>
                                                        <div className="text desc">
                                                            <Link to="#">
                                                                {product.description ? decodeHtml(product.description).replace(/<[^>]*>?/gm, '') : 'Opis će biti dostupan uskoro.'}
                                                            </Link>
                                                        </div>
                                                    </div>
                                                </div>
                                            ))}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="open-timing">
                        <div className="hours">Radno vreme od Ponedeljka do Subote: <span className="theme_color">08:00</span> do <span className="theme_color">22:30</span></div>
                        <div className="link-box">
                            <Link to="/menu" className="theme-btn btn-style-two clearfix">
                                <span className="btn-wrap">
                                    <span className="text-one">pogledajte ceo meni</span>
                                    <span className="text-two">pogledajte ceo meni</span>
                                </span>
                            </Link>
                        </div>
                    </div>
                </div>
            </section>
        </>
    )
}

export default Menusection
